import React, { useEffect, useRef, useState } from "react";
import NavbarComp1 from "../components/Navbar1";
import Footer from "../components/Footer";
import islLiveimage from "../images/live-transcript.png";

const ISL_API = "https://genislai.amritacreate.org/translatetoislfast";
const SOCKET_ID = "H-WKvNKvDdOYyhq_chpm3K14NTPHg-hg";
//const PLACEHOLDER_IMAGE = "http://aiaudio.amritacreate.org/static/media.jpg?v=1772776262";

export default function App() {
  const [started, setStarted] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [status, setStatus] = useState("Ready");
  const [segments, setSegments] = useState(0);
  const [queueCount, setQueueCount] = useState(0);
  const [showVideo, setShowVideo] = useState(false);
  const [displayText, setDisplayText] = useState("Translated text will appear here");
  const [transcripts, setTranscripts] = useState([]);
  const [islQueue, setIslQueue] = useState([]);
  const [playing, setPlaying] = useState(false);
  const [currentChunkId, setCurrentChunkId] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupVideoUrl, setPopupVideoUrl] = useState("");
  const [popupText, setPopupText] = useState("");
  const [showLoading, setShowLoading] = useState(false);

  const wsRef = useRef(null);
  const audioCtxRef = useRef(null);
  const workletRef = useRef(null);
  const micStreamRef = useRef(null);
  const islVideoRef = useRef(null);
  const lastOrig = useRef("");
  const lastEn = useRef("");
  const segmentRefs = useRef({});

  // useEffect(() => {
  //   const img = new Image();
  //   img.src = PLACEHOLDER_IMAGE;
  // }, []);

  useEffect(() => {
    if (!playing && islQueue.length > 0) playNext();
  }, [islQueue, playing]);

  useEffect(() => {
    if (currentChunkId && segmentRefs.current[currentChunkId]) {
      segmentRefs.current[currentChunkId].scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [currentChunkId]);

  useEffect(() => { setQueueCount(islQueue.length); }, [islQueue]);

  const playNext = () => {
    if (islQueue.length === 0) return;
    const item = islQueue[0];
    setPlaying(true);
    setShowVideo(true);
    setDisplayText(item.en || item.orig || "Playing...");
    setCurrentChunkId(item.chunkId || null);
    const video = islVideoRef.current;
    video.src = item.url;
    video.muted = true;
    video.play().catch(() => { setPlaying(false); setShowVideo(false); });

    // video.onended = () => {
    //   setPlaying(false);
    //   setIslQueue((prev) => {
    //     const updated = prev.slice(1);
    //     if (updated.length === 0) { setShowVideo(false); setDisplayText("Waiting for next translation..."); }
    //     return updated;
    //   });
    // };
video.onended = () => {
  setPlaying(false);

  setIslQueue((prev) => {
    const updated = prev.slice(1);

    if (updated.length === 0) {
      setShowVideo(false);

      // ✅ Only end session AFTER queue finishes
      if (!isRecording) {
        setDisplayText("Session ended");
      } else {
        setDisplayText("Waiting for next translation...");
      }
    }

    return updated;
  });
};
  };

  const start = async () => {
    try {
      setShowLoading(islQueue.length === 0);
      const wsUrl = `wss://aiaudio.amritacreate.org/stream/mic/${SOCKET_ID}`;
      const ws = new WebSocket(wsUrl);
      ws.binaryType = "arraybuffer";
      wsRef.current = ws;
      setIsRecording(true);
      ws.onopen = () => {
        setStatus("Live");
        setDisplayText("Listening...");
        ws.send(JSON.stringify({ sample_rate: 16000, language: "auto" }));
      };
      ws.onmessage = (e) => {
        const m = JSON.parse(e.data);
        if (m.type === "partial") { lastOrig.current = m.text_orig || lastOrig.current; }
        else if (m.type === "translation") { lastOrig.current = m.text_orig || lastOrig.current; lastEn.current = m.text_en || lastEn.current; }
        else if (m.type === "final") { lastOrig.current = m.text_orig || lastOrig.current; lastEn.current = m.text_en || lastEn.current; }
        else if (m.type === "isl_video") {
          setShowLoading(false);
          const textEn = m.text_en || lastEn.current;
          const textOrig = m.text_orig || lastOrig.current;
          const id = `chunk_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
          const newItem = { url: m.video_url, en: textEn, orig: textOrig, id };
          setTranscripts((prev) => [...prev, newItem]);
          setCurrentChunkId(id);
          setSegments((prev) => prev + 1);
          setIslQueue((prev) => [...prev, { ...newItem, chunkId: id }]);
            if (!isRecording) return; // ✅ ignore new items after stop
        }
      };
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      micStreamRef.current = stream;
      const audioCtx = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: 16000 });
      audioCtxRef.current = audioCtx;
      const src = audioCtx.createMediaStreamSource(stream);
      await audioCtx.audioWorklet.addModule("/processor.js");
      const workletNode = new AudioWorkletNode(audioCtx, "audio-processor");
      workletRef.current = workletNode;
      workletNode.port.onmessage = (event) => { if (ws.readyState === WebSocket.OPEN) ws.send(event.data); };
      src.connect(workletNode);
      workletNode.connect(audioCtx.destination);
    } catch (err) {
      console.error(err);
      setStatus("Mic failed");
      stop();
    }
  };

//   const stop = () => {
// setIsRecording(false);
// setStatus("Ready");

// try {
//   wsRef.current?.close();
// } catch {}

// try {
//   workletRef.current?.disconnect();
// } catch {}

// try {
//   if (audioCtxRef.current && audioCtxRef.current.state !== "closed") {
//     audioCtxRef.current.close().catch(() => {});
//   }
// } catch {}

// try {
//   micStreamRef.current?.getTracks().forEach((t) => t.stop());
// } catch {}


// if (islQueue.length === 0) {
//   setShowVideo(false);
//   setDisplayText("Session ended");
// } else {
//   setDisplayText("Finishing remaining translations...");
// }
//     try {
//       wsRef.current?.close();
//       workletRef.current?.disconnect();
//       audioCtxRef.current?.close();
//       micStreamRef.current?.getTracks().forEach((t) => t.stop());
//     } catch {}
//     if (islVideoRef.current) { islVideoRef.current.pause(); islVideoRef.current.src = ""; }
//   };

// const stop = () => {
//   setIsRecording(false);
//   setStatus("Ready");

//   try {
//     wsRef.current?.close();
//   } catch {}

//   try {
//     workletRef.current?.disconnect();
//   } catch {}

//   try {
//     if (audioCtxRef.current && audioCtxRef.current.state !== "closed") {
//       audioCtxRef.current.close().catch(() => {});
//     }
//   } catch {}

//   try {
//     micStreamRef.current?.getTracks().forEach((t) => t.stop());
//   } catch {}

//   if (islQueue.length === 0) {
//     setShowVideo(false);
//     setDisplayText("Session ended");
//   } else {
//     setDisplayText("Finishing remaining translations...");
//   }

//   if (islVideoRef.current) {
//     islVideoRef.current.pause();
//     islVideoRef.current.src = "";
//   }
// };
const stop = () => {
  setIsRecording(false);
  setStatus("Ready");

  try {
    wsRef.current?.close();
  } catch {}

  try {
    workletRef.current?.disconnect();
  } catch {}

  try {
    if (audioCtxRef.current && audioCtxRef.current.state !== "closed") {
      audioCtxRef.current.close().catch(() => {});
    }
  } catch {}

  try {
    micStreamRef.current?.getTracks().forEach((t) => t.stop());
  } catch {}

  // ❗ DO NOT stop video here
  if (islQueue.length === 0) {
    setShowVideo(false);
    setDisplayText("Session ended");
  } else {
    setDisplayText("Finishing remaining translations...");
  }
};
  const toggle = () => (isRecording ? stop() : start());

  const openPopup = (videoUrl, text) => { if (!videoUrl) return; setPopupVideoUrl(videoUrl); setPopupText(text); setShowPopup(true); };
  const closePopup = () => { setShowPopup(false); setPopupVideoUrl(""); };

  const scrollToCurrent = () => {
    if (currentChunkId && segmentRefs.current[currentChunkId]) {
      segmentRefs.current[currentChunkId].scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const currentSegment = transcripts.find((t) => t.id === currentChunkId);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap');

        .lv-root, .lv-root * { box-sizing: border-box; }
        .lv-root {
          font-family: 'Plus Jakarta Sans', 'Segoe UI', sans-serif;
          background: #EDEEF2;
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }

        /* ── PAGE BODY ── */
        .lv-body {
          flex: 1;
          display: grid;
          grid-template-columns: 58% 1fr;
          gap: 16px;
          padding: 20px 20px 32px;
          /* max-width: 1100px;*/
          width: 100%;
          margin: 0 auto;
          align-items: start;
        }
        @media (max-width: 820px) { .lv-body { grid-template-columns: 1fr; } }

        /* ── CARD ── */
        .lv-card {
          background: #fff;
          border-radius: 20px;
          border: 1px solid #E2E5EC;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }

        /* ── LEFT CARD HEADER ── */
        .lv-card-head {
          padding: 18px 22px 16px;
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 12px;
        }
        .lv-brand-kicker {
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: #b0004e;
          margin-bottom: 3px;
        }
        .lv-brand-title {
          font-size: 18px;
          font-weight: 700;
          color: #0D1117;
          line-height: 1.25;
        }
        .lv-brand-title span {
          background: linear-gradient(90deg, #b0004e, #5d072e);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        /* ── BUTTONS ── */
        .lv-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 10px 22px;
          border-radius: 12px;
          font-size: 13px;
          font-weight: 700;
          border: none;
          cursor: pointer;
          transition: transform 0.12s, box-shadow 0.15s;
          white-space: nowrap;
          flex-shrink: 0;
        }
        .lv-btn:active { transform: scale(0.96); }
        .lv-btn-start {
          background: #12B76A;
          color: #fff;
          box-shadow: 0 2px 8px rgba(18,183,106,0.3);
        }
        .lv-btn-start:hover { background: #0E9356; box-shadow: 0 4px 16px rgba(18,183,106,0.4); }
        .lv-btn-stop {
          background: #F04438;
          color: #fff;
          box-shadow: 0 2px 8px rgba(240,68,56,0.3);
        }
        .lv-btn-stop:hover { background: #D92D20; box-shadow: 0 4px 16px rgba(240,68,56,0.4); }
        .lv-btn-dot {
          width: 8px; height: 8px;
          border-radius: 50%;
          background: rgba(255,255,255,0.7);
          flex-shrink: 0;
        }
        .lv-btn-stop .lv-btn-dot { border-radius: 2px; }

        /* ── VIDEO WRAPPER ── */
        .lv-video-wrap {
          position: relative;
          background: #080C12;
          aspect-ratio: 16/9;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }
        .lv-video-placeholder {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 14px;
        }
        .lv-mic-outer {
          width: 72px; height: 72px;
          border-radius: 50%;
          background: rgba(168, 6, 95, 0.08);
          border: 1px solid rgba(177, 16, 104, 0.2);
          display: flex; align-items: center; justify-content: center;
          position: relative;
        }
        .lv-mic-outer::before {
          content: '';
          position: absolute;
          inset: -8px;
          border-radius: 50%;
          border: 1px solid rgba(177, 16, 104,0.1);
        }
        .lv-placeholder-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          opacity: 0.6;
          position: absolute;
          inset: 0;
        }
        .lv-placeholder-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg, rgba(8,12,18,0.3) 0%, rgba(8,12,18,0.7) 100%);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 14px;
        }
        .lv-placeholder-txt {
          font-size: 13px;
          font-weight: 600;
          color: rgba(255,255,255,0.55);
          letter-spacing: 0.01em;
        }
        .lv-preview-video {
          width: 100%; height: 100%;
          object-fit: contain;
          display: none;
        }
        .lv-preview-video.show { display: block; }

        /* ── QUEUE PILL ── */
        .lv-queue-pill {
          position: absolute;
          top: 12px; right: 12px;
          background: rgba(15,20,30,0.65);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(253,176,34,0.4);
          border-radius: 30px;
          padding: 5px 12px;
          font-size: 11px;
          font-weight: 700;
          color: #FDB022;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .lv-queue-blink {
          width: 6px; height: 6px;
          border-radius: 50%;
          background: #FDB022;
          animation: lv-blink 1s ease infinite;
        }
        @keyframes lv-blink { 0%,100%{opacity:1} 50%{opacity:0.2} }

        /* ── WAVEFORM ── */
        .lv-waveform {
          position: absolute;
          bottom: 14px; left: 50%;
          transform: translateX(-50%);
          display: flex; align-items: flex-end; gap: 3px;
          opacity: 0;
          transition: opacity 0.4s;
        }
        .lv-waveform.live { opacity: 1; }
        .lv-wbar {
          width: 3px; border-radius: 3px;
          background: #b0004e;
          animation: lv-wavebar 0.9s ease-in-out infinite;
        }
        .lv-wbar:nth-child(1){height:6px;animation-delay:0.0s}
        .lv-wbar:nth-child(2){height:12px;animation-delay:0.1s}
        .lv-wbar:nth-child(3){height:18px;animation-delay:0.15s}
        .lv-wbar:nth-child(4){height:22px;animation-delay:0.2s}
        .lv-wbar:nth-child(5){height:18px;animation-delay:0.25s}
        .lv-wbar:nth-child(6){height:12px;animation-delay:0.3s}
        .lv-wbar:nth-child(7){height:6px;animation-delay:0.35s}
        @keyframes lv-wavebar { 0%,100%{transform:scaleY(1)} 50%{transform:scaleY(1.8)} }

        /* ── TRANSLATION BAR ── */
        .lv-tbar-wrap { padding: 14px 22px; border-top: 1px solid #F0F2F6; }
        .lv-tbar {
          display: flex; align-items: center; gap: 10px;
          background: #F7F9FC;
          border: 1px solid #E8EBF1;
          border-radius: 12px;
          padding: 11px 16px;
          font-size: 13.5px;
          color: #9AA3B2;
          min-height: 44px;
          line-height: 1.55;
          transition: all 0.25s;
        }
        .lv-tbar.active { color: #0D1117; border-color: #CDD3DE; background: #fff; }
        .lv-tbar-icon { flex-shrink: 0; opacity: 0.4; }
        .lv-tbar.active .lv-tbar-icon { opacity: 0.7; }

        /* ── STATUS ROW ── */
        .lv-status-row {
          padding: 10px 22px 18px;
          display: flex; align-items: center; justify-content: space-between;
        }
        .lv-live-badge {
          display: inline-flex; align-items: center; gap: 7px;
          font-size: 12px; font-weight: 700; color: #12B76A;
        }
        .lv-live-dot {
          width: 8px; height: 8px; border-radius: 50%;
          background: #12B76A;
          position: relative;
        }
        .lv-live-dot::after {
          content: '';
          position: absolute; inset: -4px;
          border-radius: 50%;
          background: rgba(18,183,106,0.2);
          animation: lv-ripple 1.6s ease-out infinite;
        }
        @keyframes lv-ripple { 0%{transform:scale(0.7);opacity:1} 100%{transform:scale(2);opacity:0} }
        .lv-idle-badge {
          display: inline-flex; align-items: center; gap: 7px;
          font-size: 12px; font-weight: 600; color: #9AA3B2;
        }
        .lv-idle-dot { width: 8px; height: 8px; border-radius: 50%; background: #CDD3DE; }
        .lv-seg-count { font-size: 12px; font-weight: 500; color: #9AA3B2; }

        /* ── RIGHT CARD ── */
        .lv-right-head {
          padding: 18px 22px 0;
          display: flex; align-items: center; justify-content: space-between;
        }
        .lv-right-title {
          font-size: 13px; font-weight: 700;
          color: #0D1117; letter-spacing: 0.04em;
          text-transform: uppercase;
        }
        .lv-seg-badge {
          background: #F0F2F6;
          border-radius: 20px;
          padding: 3px 10px;
          font-size: 11px;
          font-weight: 700;
          color: #6B7280;
        }

        /* ── NOW PLAYING STICKY ── */
        .lv-now-sticky {
          position: sticky;
          top: 0; z-index: 10;
          background: #fff;
          padding: 12px 16px 10px;
          border-bottom: 1px solid #F0F2F6;
        }
        .lv-now-card {
          background: #ffedf5;
          border: 1px solid #dfc4d0;
          border-radius: 14px;
          padding: 13px 16px;
          cursor: pointer;
          transition: border-color 0.15s;
        }
        .lv-now-card:hover { border-color: #85013c; }
        .lv-now-label {
          display: flex; align-items: center; gap: 6px;
          font-size: 10px; font-weight: 800;
          color: #b0004e; letter-spacing: 0.1em;
          text-transform: uppercase;
          margin-bottom: 7px;
        }
        .lv-now-dot {
          width: 6px; height: 6px; border-radius: 50%;
          background: #b0004e;;
          animation: lv-blink 1.2s infinite;
        }
        .lv-now-orig { font-size: 14px; font-weight: 600; color: #0D1117; line-height: 1.5; }
        .lv-now-en { font-size: 12px; color: #667085; margin-top: 3px; font-style: italic; }
        .lv-now-hint { font-size: 10px; color: #bf125d; margin-top: 4px; text-align: right; }

        /* ── TRANSCRIPT LIST ── */
        .lv-list-wrap {
          flex: 1;
          overflow-y: auto;
          padding: 10px 16px 16px;
          display: flex; flex-direction: column; gap: 6px;
          max-height: 380px;
        }
        .lv-list-wrap::-webkit-scrollbar { width: 4px; }
        .lv-list-wrap::-webkit-scrollbar-track { background: transparent; }
        .lv-list-wrap::-webkit-scrollbar-thumb { background: #E2E5EC; border-radius: 4px; }

        .lv-chunk {
          display: flex; gap: 10px; align-items: flex-start;
          padding: 11px 14px;
          border-radius: 12px;
          border: 1px solid #F0F2F6;
          background: #FCFCFE;
          cursor: pointer;
          transition: border-color 0.15s, background 0.15s, transform 0.12s;
        }
        .lv-chunk:hover { border-color: #D0D5DD; background: #F7F9FC; transform: translateX(2px); }
        .lv-chunk-active {
          border-color: #bf125d;
          background: #ffedf5;
          border-left: 3px solid #b0004e !important;
          transform: translateX(0) !important;
        }
        .lv-chunk-active.lv-pulse {
          animation: lv-chunk-glow 2s ease-in-out infinite;
        }
        @keyframes lv-chunk-glow {
          0%,100%{box-shadow:0 0 0 0 rgba(18,183,106,0)} 
          50%{box-shadow:0 0 0 3px rgba(18,183,106,0.15)}
        }
        .lv-chunk-num {
          font-size: 11px; font-weight: 700; color: #CDD3DE;
          min-width: 18px; padding-top: 1px; flex-shrink: 0;
          transition: color 0.15s;
        }
        .lv-chunk-active .lv-chunk-num { color: #b0004e; }
        .lv-chunk-orig { font-size: 13px; font-weight: 500; color: #1A2332; line-height: 1.55; }
        .lv-chunk-en { font-size: 12px; color: #8C94A3; margin-top: 2px; font-style: italic; }

        /* ── FOOTER HINT ── */
        .lv-list-footer {
          padding: 6px 16px 14px;
          font-size: 10px; color: #C5CAD4; text-align: right;
        }

        /* ── EMPTY STATE ── */
        .lv-empty {
          padding: 48px 20px;
          display: flex; flex-direction: column; align-items: center; gap: 12px;
        }
        .lv-empty-ring {
          width: 56px; height: 56px; border-radius: 50%;
          background: #F4F6FA; border: 1px solid #E8EBF1;
          display: flex; align-items: center; justify-content: center;
        }
        .lv-empty-txt { font-size: 13px; color: #9AA3B2; text-align: center; line-height: 1.8; }

        /* ── SHIMMER ── */
        .lv-shimmer {
          margin: 0 16px 14px;
          border-radius: 12px;
          border: 1px dashed #E2E5EC;
          background: #FAFBFC;
          padding: 13px 16px;
          display: flex; flex-direction: column; gap: 8px;
        }
        .lv-shimmer-bar {
          height: 10px; border-radius: 6px;
          background: linear-gradient(90deg, #EEF0F5 25%, #E2E5EC 50%, #EEF0F5 75%);
          background-size: 200% 100%;
          animation: lv-sh 1.5s infinite;
        }
        .lv-shimmer-bar.s { width: 55%; }
        @keyframes lv-sh { 0%{background-position:200% 0} 100%{background-position:-200% 0} }

        /* ── POPUP ── */
        .lv-overlay {
          position: fixed; inset: 0;
          background: rgba(8,12,18,0.65);
          backdrop-filter: blur(6px);
          display: flex; align-items: center; justify-content: center;
          z-index: 9999;
        }
        .lv-popup {
          background: #fff;
          border-radius: 22px;
          padding: 22px;
          width: 400px; max-width: 94vw;
          display: flex; flex-direction: column; gap: 14px;
          position: relative;
          box-shadow: 0 24px 80px rgba(8,12,18,0.3);
        }
        .lv-popup-close {
          position: absolute; top: 16px; right: 16px;
          background: #F0F2F6; border: none;
          border-radius: 10px;
          width: 32px; height: 32px;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; font-size: 13px; font-weight: 700;
          color: #6B7280; transition: background 0.15s;
        }
        .lv-popup-close:hover { background: #E2E5EC; }
        .lv-popup-title {
          font-size: 15px; font-weight: 700; color: #0D1117;
          text-align: center; padding-right: 28px;
        }
        .lv-popup video {
          width: 100%; border-radius: 12px; background: #0D1117;
        }
        .lv-popup-txt {
          font-size: 13px; color: #6B7280;
          text-align: center; line-height: 1.65;
        }
      `}</style>

      <div className="lv-root">
        <NavbarComp1 />

        <div className="lv-body">

          {/* ════════════════ LEFT: VIDEO ════════════════ */}
          <div className="lv-card">

            <div className="lv-card-head">
              <div>
                <div className="lv-brand-kicker">Live ISL</div>
                <div className="lv-brand-title">
                  Real-time <span>speech to ISL</span>
                </div>
              </div>
              <button
                className={`lv-btn ${isRecording ? "lv-btn-stop" : "lv-btn-start"}`}
                onClick={toggle}
              >
                <span className="lv-btn-dot" />
                {isRecording ? "Stop" : "Start"}
              </button>
            </div>

            <div className="lv-video-wrap">
              {!showVideo && (
                <>
                  <img src={islLiveimage} alt="preview" className="lv-placeholder-img" />
                  <div className="lv-placeholder-overlay">
                    <div className="lv-mic-outer">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="rgba(228, 10, 144, 0.7)" strokeWidth="1.5">
                        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
                        <path d="M19 10v2a7 7 0 0 1-14 0v-2M12 19v4M8 23h8"/>
                      </svg>
                    </div>
                    <span className="lv-placeholder-txt">
                      {isRecording ? "Waiting for translation..." : "Press Start to begin"}
                    </span>
                  </div>
                </>
              )}

              <video
                ref={islVideoRef}
                autoPlay
                playsInline
                className={`lv-preview-video${showVideo ? " show" : ""}`}
              />

              {queueCount > 0 && (
                <div className="lv-queue-pill">
                  <span className="lv-queue-blink" />
                  {queueCount} in queue
                </div>
              )}

              <div className={`lv-waveform${isRecording ? " live" : ""}`}>
                {[1,2,3,4,5,6,7].map(i => <span key={i} className="lv-wbar" />)}
              </div>
            </div>

            <div className="lv-tbar-wrap">
              <div className={`lv-tbar${
                displayText !== "Translated text will appear here" && displayText !== "Session ended"
                  ? " active" : ""
              }`}>
                <svg className="lv-tbar-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                </svg>
                {displayText}
              </div>
            </div>

            <div className="lv-status-row">
              {status === "Live" ? (
                <span className="lv-live-badge"><span className="lv-live-dot" /> Live</span>
              ) : (
                <span className="lv-idle-badge"><span className="lv-idle-dot" /> {status}</span>
              )}
              <span className="lv-seg-count">{segments} segment{segments !== 1 ? "s" : ""}</span>
            </div>

          </div>

          {/* ════════════════ RIGHT: TRANSCRIPT ════════════════ */}
          <div className="lv-card" style={{ minHeight: 0 }}>

            <div className="lv-right-head" style={{ paddingBottom: 14 }}>
              <span className="lv-right-title">Live Transcription</span>
              {segments > 0 && (
                <span className="lv-seg-badge">{segments}</span>
              )}
            </div>

            {currentSegment && (
              <div className="lv-now-sticky">
                <div className="lv-now-card" onClick={scrollToCurrent}>
                  <div className="lv-now-label">
                    <span className="lv-now-dot" />
                    Now Playing
                  </div>
                  <div className="lv-now-orig">{currentSegment.orig || "Start streaming..."}</div>
                  {currentSegment.en && (
                    <div className="lv-now-en">{currentSegment.en}</div>
                  )}
                  <div className="lv-now-hint">Tap to scroll ↓</div>
                </div>
              </div>
            )}

            <div className="lv-list-wrap">
              {transcripts.length === 0 ? (
                <div className="lv-empty">
                  <div className="lv-empty-ring">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#9AA3B2" strokeWidth="1.5">
                      <rect x="3" y="3" width="18" height="18" rx="3"/>
                      <path d="M7 8h10M7 12h10M7 16h6"/>
                    </svg>
                  </div>
                  <span className="lv-empty-txt">No transcripts yet.<br />Start a session to see live results.</span>
                </div>
              ) : (
                transcripts.map((t, i) => {
                  const isCurrent = t.id === currentChunkId;
                  return (
                    <div
                      key={t.id}
                      ref={(node) => { if (node) segmentRefs.current[t.id] = node; }}
                      className={`lv-chunk${isCurrent ? " lv-chunk-active lv-pulse" : ""}`}
                      onClick={() => {
                        setCurrentChunkId(t.id);
                        if (segmentRefs.current[t.id]) {
                          segmentRefs.current[t.id].scrollIntoView({ behavior: "smooth", block: "center" });
                        }
                        openPopup(t.url, t.en || t.orig);
                      }}
                    >
                      <span className="lv-chunk-num">{i + 1}</span>
                      <div style={{ flex: 1 }}>
                        <div className="lv-chunk-orig">{t.orig}</div>
                        {t.en && <div className="lv-chunk-en">{t.en}</div>}
                      </div>
                    </div>
                  );
                })
              )}
            </div>

            {showLoading && (
              <div className="lv-shimmer">
                <div className="lv-shimmer-bar" style={{ width: "80%" }} />
                <div className="lv-shimmer-bar s" />
              </div>
            )}

            {transcripts.length > 0 && (
              <div className="lv-list-footer">Click any segment to replay its sign video</div>
            )}

          </div>
        </div>

        <Footer />
      </div>

      {showPopup && (
        <div className="lv-overlay" onClick={closePopup}>
          <div className="lv-popup" onClick={(e) => e.stopPropagation()}>
            <button
              className="lv-popup-close"
              onClick={(e) => { e.stopPropagation(); e.preventDefault(); closePopup(); }}
            >✕</button>
            <div className="lv-popup-title">Sign Language Replay</div>
            <video src={popupVideoUrl} autoPlay controls />
            <div className="lv-popup-txt">{popupText}</div>
          </div>
        </div>
      )}
    </>
  );
}
